import { THREE } from '@powerplay/common';
import { LightTypes } from './types';
import { lightConfig } from './config';
export class LightsManager {
    #lights = {
        dirMain: new THREE.DirectionalLight(0xffffff)
    };
    constructor(scene) {
        this.setLight(LightTypes.directionalMain, lightConfig.lightVector, 0.9, scene);
    }
    get lights() {
        return this.#lights;
    }
    getLight(light) {
        return this.lights[light];
    }
    setLight(light, position, intensity, scene) {
        this.lights[light].position.set(position.x, position.y, position.z);
        if (intensity >= 0)
            this.lights[light].intensity = intensity;
        this.lights[light].layers.set(1);
        scene.add(this.lights[light]);
    }
    setEnabled = (enabled, light) => {
        this.lights[light].visible = enabled;
    };
    followLightWithObject(object) {
        const light = this.lights.dirMain;
        light.position.set(object.position.x + lightConfig.lightVector.x, object.position.y + lightConfig.lightVector.y, object.position.z + lightConfig.lightVector.z);
        light.target.position.set(object.position.x, object.position.y, object.position.z);
        light.target.updateMatrixWorld();
    }
}
//# sourceMappingURL=LightsManager.js.map